/** Path segments on the authorization service (no leading slash). */
export const ADMIN_APPLICATIONS_PATH = 'admin/applications';
export const ADMIN_ROLES_PATH = 'admin/roles';
export const ADMIN_ROLE_TYPES_PATH = 'admin/role-types';
export const ADMIN_FEATURES_PATH = 'admin/features';
export const ADMIN_PERMISSIONS_PATH = 'admin/permissions';
export const ADMIN_AUDIT_LOGS_PATH = 'admin/audit-logs';
export const ADMIN_SERVICE_COMMUNICATIONS_PATH = 'admin/service-communications';

/** Global service catalog (flat CRUD) — services are global with M:N application assignment. */
export const ADMIN_SERVICES_PATH = 'admin/services';

export const adminServicePath = (serviceRowId: string): string =>
  `${ADMIN_SERVICES_PATH}/${encodeURIComponent(serviceRowId)}`;

/** Assignment routes: services ASSIGNED to an application (do not own/delete services). */
export const applicationServicesPath = (appId: string): string =>
  `${ADMIN_APPLICATIONS_PATH}/${encodeURIComponent(appId)}/services`;

export const applicationServicePath = (appId: string, serviceRowId: string): string =>
  `${applicationServicesPath(appId)}/${encodeURIComponent(serviceRowId)}`;

export const applicationServiceCommunicationsPath = (appId: string, serviceRowId: string): string =>
  `${applicationServicePath(appId, serviceRowId)}/communications`;

/** @deprecated Use {@link ADMIN_APPLICATIONS_PATH} */
export const ADMIN_DOMAINS_PATH = ADMIN_APPLICATIONS_PATH;

/** Browser calls this Next route; it proxies to `AGA_SERVICE_AUTHORIZATION_URL`. */
export const AUTHORIZATION_PROXY_BASE = '/api/authorization-service';
